import { validate as cnpj } from './validation.cnpj.js';

export const allowedColors = [
  '#FF0000', // Vermelho
  '#00FF00', // Verde
  '#0000FF', // Azul
  '#FFFFFF', // Branco
  '#FFD580', // Laranja Claro
  '#FF6666', // Vermelho Claro
  '#FFA500', // Laranja
  '#FFFF00', // Amarelo
  '#90EE90', // Verde Claro
  '#BFFF00', // Verde Limão
  '#D580FF', // Roxo Claro
  '#800080', // Roxo
];

export const newAllowedColors = [
  '#DC3545', // Vermelho Escuro
  '#28A745', // Verde Escuro
  '#005FCC', // Azul Escuro
  '#FFF0DE', // Branco Escuro (#FFF0DE)
  '#FFD580', // Laranja Claro (#FFD580)
  '#FF6666', // Vermelho Claro (#FF6666)
  '#DD5B16', // Laranja Escuro (#DD5B16)
  '#E5AA08', // Amarelo Escuro (#E5AA08)
  '#90EE90', // Verde Claro (#90EE90)
  '#BFFF00', // Verde Limão (#BFFF00)
  '#D10092', // Roxo Claro (#D10092)
  '#720087', // Roxo (#720087)
];

export function getColorsMask(color: string): string {
  switch (color.toUpperCase()) {
    case '#FF0000':
      return '#DC3545'; // Vermelho Escuro
    case '#00FF00':
      return '#28A745'; // Verde Escuro
    case '#0000FF':
      return '#005FCC'; // Azul Escuro
    case '#FFFFFF':
      return '#FFF0DE'; // Branco Escuro
    case '#FFD580':
      return '##F2F2F2'; // Laranja Claro
    case '#FF6666':
      return '#FF6666'; // Vermelho Claro
    case '#FFA500':
      return '#DD5B16'; // Laranja Escuro
    case '#FFFF00':
      return '#E5AA08'; // Amarelo Escuro
    case '#90EE90':
      return '#90EE90'; // Verde Claro
    case '#BFFF00':
      return '#BFFF00';
    case '#D580FF':
      return '#D10092'; // Roxo Claro
    case '#800080':
      return '#720087'; // Roxo
    default:
      return color;
  }
}

export function getLabelColorsMask(color: string): string {
  switch (color.toUpperCase()) {
    case '#FF0000':
      return 'Vermelho'; // Vermelho Escuro
    case '#00FF00':
      return 'Verde'; // Verde Escuro
    case '#0000FF':
      return 'Azul'; // Azul Escuro
    case '#FFFFFF':
      return 'Branco Quente'; // Branco Escuro
    case '#FFD580':
      return 'Branco Frio'; // Laranja Claro
    case '#FF6666':
      return 'Vermelho Claro'; // Vermelho Claro
    case '#FFA500':
      return 'Laranja Escuro'; // Laranja Escuro
    case '#FFFF00':
      return 'Amarelo Escuro'; // Amarelo Escuro
    case '#90EE90':
      return 'Verde Claro'; // Verde Claro
    case '#BFFF00':
      return 'Verde Limão'; // Verde Limão
    case '#D580FF':
      return 'Rosa'; // Roxo Claro
    case '#800080':
      return 'Roxo'; // Roxo
    default:
      return color;
  }
}

export const validation = {
  cnpj,
  cep: (value: string) => /^\d{5}-?\d{3}$/.test(value),
  color: (value: string) => /^#(?:[0-9a-fA-F]{6})$/i.test(value),
  ledColor: (value: string) => {
    return allowedColors.includes(value.toUpperCase());
  },
  email: (value: string) =>
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(
      value
    ),
  mobile: (value: string) => /^(55)?[0-9]{2}[1-9][0-9]{8}$/i.test(value),
  uuid: (value: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value),
  fullname: (value: string) => /^[\p{L}]{2,}(?:\s[\p{L}]{2,}){1,}\s*$/u.test(value),
  password: (value: string) => /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(value),
};

export const colorErrorMessage = 'Cor inválida. As cores permitidas são:\n' + Object.values(allowedColors).join(', ');
